import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type TriviaResults = paths['/trivia/{slug}/results/'];

const postTriviaResults = createRequest<TriviaResults, 'post'>('/pc/trivia/{slug}/results/', 'POST');

export default postTriviaResults;
